module.exports = __webpack_public_path__ + "static/media/upVoteicon.3094921e.png";